import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { colors } from '../styles/colors';
import * as XLSX from 'xlsx';
import Dexie from 'dexie';
import '../styles/font.css'
import we2Blue from '../assets/we2Blue.svg';

const Home = () => {
    const [dbData, setDbData] = useState(null);
    // const [gameStart , setGameStart] = useState(false);
    const navigate = useNavigate();


    const db = new Dexie('myDb');
    db.version(1).stores({
        files: '++id, name, data',
    });

    const handleUploadFile = (e) => {
        // console.log("handleUploadFile");
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            const fileData = e.target.result;
            const workbook = XLSX.read(fileData, { type: 'binary' });

            const rows = [];

            workbook.SheetNames.forEach(sheet => {
                const rowObject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet]);
                rows.push(...rowObject);
            });

            // console.log(rows , 'rows');

            db.files.add({ name: file.name, data: rows })
                .then(() => {
                    // console.log('Data added to IndexedDB');
                    fetchDataFromIndexedDB();
                })
                .catch(error => {
                    console.error('Error adding data to IndexedDB', error);
                });
        };

        reader.readAsBinaryString(file);
    };

    const fetchDataFromIndexedDB = useCallback(() => {
        db.files.toArray()
            .then(files => {
                // console.log(files);
                setDbData(files);
            })
            .catch(error => {
                console.error('Error getting data from IndexedDB', error);
            });
    }, []);
    const toggleFullScreen = () => {
        
      };

    useEffect(() => {
        toggleFullScreen();
        fetchDataFromIndexedDB();
    }, [fetchDataFromIndexedDB]);
    const handleClick = (file) => {
        const getEle = document.getElementById('full-screen');
        if (getEle) {
            if (getEle.requestFullscreen) {
                // console.log('requestFullscreen');
                getEle.requestFullscreen();
            } else if (getEle.webkitRequestFullScreen) {
                getEle.webkitRequestFullScreen();
            } else if (getEle.mozRequestFullScreen) {
                getEle.mozRequestFullScreen();
            } else if (getEle.msRequestFullscreen) {
                getEle.msRequestFullscreen();
            }
        }
        // console.log(file);
        navigate('/quiz', { state: { file: file } });
    };


    // console.log(dbData);

    return (
        <div
            className='mx-auto flex justify-center h-screen w-screen sm:h-screen sm:w-screen md:h-screen md:w-screen lg:h-screen lg:w-screen xl:h-screen xl:w-screen'
            style={{ backgroundColor: colors.primaryColor }}
        >
            <div className='text-center mt-18 sm:mt-10 md:mt-20 lg:mt-40'>

                <h1
                    // className='mt-10'
                    style={{
                        color: colors.secondaryColor,
                        fontSize: 'clamp(1.875rem, 0.5106rem + 4.3662vw, 5.75rem)',
                        fontStyle: 'normal',
                        lineHeight: 'normal',
                        
                        fontWeight: '900',
                        // lineHeight: '110px',
                    }}
                >
                    Keyboard Shortcut Tester
                </h1>
                <h1
                    className='mt-20'
                    style={{
                        color: colors.darkGrey,
                        fontSize: '20px',
                        fontStyle: 'normal',
                        fontWeight: '900',
                        lineHeight: '23.22px',
                    }}
                >
                    Upload a CSV file or choose from one of the existing sets to test your shortcut knowledge!
                </h1>
                <div className='mt-10 p-2 mx-auto'>
                    <div className='flex flex-wrap'>
                        <label className='mr-4 mb-4 box-border h-52 w-52 p-8 border-4' style={{
                            color: colors.darkGrey,
                            borderColor: colors.darkGrey,
                            
                        }}>
                            <input
                                onChange={handleUploadFile}
                                type="file" className="hidden" />
                            <img src={require('../assets/plus.png')}  alt="plus" className='h-14 w-14 mx-auto' />
                            <h1 style={{
                                fontSize: '20px',
                                fontStyle: 'normal',
                                fontWeight: '900',
                                lineHeight: 'normal',
                                marginTop: '44px',
                            }}>Upload CSV</h1>
                        </label>
                        {dbData && dbData?.map((file) => (
                            <div id='full-screen' key={file.id} className='mr-4 mb-4 box-border h-52 w-52 p-8 border-4' style={{
                                // color: colors.darkGrey,
                                borderColor: colors.darkGrey,
                            }}
                                onClick={() => handleClick(file)}
                            >
                            <div>
                                <h1 style={{
                                    color: colors.darkGrey,
                                    // textAlign: 'center',
                                    fontSize: '29px',
                                    fontStyle: 'normal',
                                    fontWeight: '900',
                                    lineHeight: 'normal',
                                }} className='mt-2'>{file.data[0].ToolName}</h1>
                            </div>
                            <div className='mt-4'>
                                <span style={{
                                    color: colors.darkGrey,
                                    // textAlign: 'center',
                                    fontSize: '25px',
                                    fontStyle: 'normal',
                                    fontWeight: '400',
                                    lineHeight: 'normal',
                                }} className=''>{file.data[0].KeysetName}</span>
                            </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
            <div style={{ position: 'absolute', bottom: 0, right: 0 }}>
                <img src={we2Blue} alt="keyboard" sx={{
                    width: '156px',
                    height: '117px',
                }} />
            </div>
        </div>
    );
};

export default Home;
